module.exports = __webpack_public_path__ + "img/gbmg_login.0bb14150.svg";